export enum InactivityTimerStatus {
    ShowSessionWarningDialog,
    TimeOutandRedirect
}
